import { getData } from ".."

const defaultState = {
    ingredient: null,
    usageCount: null,
    usageCountError: false,
    nbGroups: 0,
    nbFamilies: 0,
    nbAllergens: 0,
    associatedSupplierItems: []
}

const isDisplayedIngredient = (state, commercialNameId) => !!state.ingredient && state.ingredient.objectId === commercialNameId

export default function (state = defaultState, action) {
    switch (action && action.type) {
        case "INGREDIENTS_CLASSIFICATIONS_LOADED":
            return {
                ...state,
                nbGroups: action.nbGroups,
                nbFamilies: action.nbFamilies,
                nbAllergens: action.nbAllergens
            }
        case "INGREDIENT_LOADED":
            // The update actions re-dispatch INGREDIENT_LOADED for the displayed ingredient without reloading
            // the count: it is reset only when another ingredient is displayed, so the previous one's count never shows
            if (isDisplayedIngredient(state, action.ingredient?.objectId)) {
                return { ...state, ingredient: action.ingredient }
            }

            return {
                ...state,
                ingredient: action.ingredient,
                usageCount: null,
                usageCountError: false
            }
        case "COMMERCIAL_NAME_USAGE_COUNT_LOADING":
            // A response or a failure for another ingredient than the displayed one is ignored: the request
            // outlives the navigation and must never overwrite the current ingredient's count
            if (!isDisplayedIngredient(state, action.commercialNameId)) {
                return state
            }

            return {
                ...state,
                usageCount: null,
                usageCountError: false
            }
        case "COMMERCIAL_NAME_USAGE_COUNT_LOADED":
            if (!isDisplayedIngredient(state, action.commercialNameId)) {
                return state
            }

            return {
                ...state,
                usageCount: action.usageCount,
                usageCountError: false
            }
        case "COMMERCIAL_NAME_USAGE_COUNT_FAILED":
            if (!isDisplayedIngredient(state, action.commercialNameId)) {
                return state
            }

            return {
                ...state,
                usageCountError: true
            }
        case "INGREDIENT_SUPPLIER_ITEMS_LOADED":
            return {
                ...state,
                associatedSupplierItems: action.supplierItems
            }
        default:
            return {
                ...state
            }
    }
}

//------------------------------------------------------------------//
//--------------------------- Selectors ----------------------------//
//------------------------------------------------------------------//
export function getIngredient(state, errorIfNotFound = false) {
    return getData(state, "ingredientsPage.ingredient", errorIfNotFound && "No ingredient found")
}

export function getAssociatedSupplierItems(state, errorIfNotFound = false) {
    return getData(state, "ingredientsPage.associatedSupplierItems", errorIfNotFound && "No associated supplier items found")
}

export function getCommercialNameUsageCountSelector(state) {
    return state.ingredientsPage.usageCount
}

export function getCommercialNameUsageCountErrorSelector(state) {
    return state.ingredientsPage.usageCountError
}